import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'gw-portals-util-js/FunUtil';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

const fn = (
    $state, $translate, $scope, $q, $stateParams, AccountService, PolicyService, ActivityService, $modal,
    $window, ModalService, $filter, UserService, TranslateService, GPA_PC_ENTRY_POINT
) => {
    const ctrl = Object.create(BaseCtrl);
    const SupportedTransactionLOBs = ['BOPLine', 'CPLine'];

    ctrl.init = () => {
        initialiseScopeVariables();
    };

    /* Private Functions*/
    function initialiseScopeVariables() {
        $scope.policyTransactionTableConfig = {
            transactionStatus: '',
            policyTransactionStatus: [],
            source: 'account',
            search: ''
        };

        getPolicyTransactionStatus();

        $scope.activityTableConfig = {
            actStatus: 'allOpen',
            defaultActStatus: 'allOpen',
            actStatusOptions: {
                'allOpen': 'gateway.directives.ActivitySummary.All Open',
                'allClosed': 'gateway.directives.ActivitySummary.All Closed',
                'overdue': 'gateway.directives.ActivitySummary.Overdue',
                'openAssignedToMe': 'gateway.directives.ActivitySummary.Open, Assigned to me'
            },
            showAddActivity: false
        };

        $scope.documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved',
            policyNumber: $stateParams.policyNumber
        };

        $scope.policyNumber = $stateParams.policyNumber;
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
        $scope.changeFormIsVisible = false;
        $scope.renewFormIsVisible = false;
        $scope.currentDate = new Date();
        $scope.effectiveDate = new Date();
        $scope.makerWarrantyEnd = new Date();
        const applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.enableClaims = applicationFeatures.gatewayclaims === 'true';
        $scope.gatewayEndorsementEnabled = applicationFeatures.gatewayendorsement === 'true';
        $scope.gatewayCancelationEnabled_PSA = applicationFeatures.gatewayCancelation_PSA === 'true'; // PSA
        $scope.gatewayRenewalEnabled_PSA = applicationFeatures.gatewayRenewal_PSA === 'true'; // PSA
    }

    function getPolicyTransactionStatus() {
        const status = [{
            value: 'all',
            name: '',
            displayKey: 'gateway.views.account-detail.All'
        }, {
            value: 'Draft',
            name: '',
            displayKey: 'typekey.PolicyPeriodStatus.Draft'
        }];

        $scope.policyTransactionTableConfig.policyTransactionStatus = translatePolicyTransactionStatuses(status);
        $scope.policyTransactionTableConfig.transactionStatus = status[0]; // all
    }

    function translatePolicyTransactionStatuses(statuses) {
        statuses.forEach((status) => {
            TranslateService.translate({
                object: status,
                propName: 'name',
                displayKey: status.displayKey,
                scope: $scope
            });
        });

        return statuses;
    }

    /* Should this be scope level and overrideable?*/

    ctrl.showAddActivity = () => {
        $scope.activityTableConfig.showAddActivity = true;
    };

    ctrl.shouldShowAddActivityButton = () => {
        const permissionDTO = {
            permission: 'actcreate'
        };

        const actPromise = UserService.hasUserSystemPermission(permissionDTO);

        actPromise.then((showActivity) => {
            $scope.showAddActivityButton = showActivity;
        });
    };

    ctrl.shouldShowAddActivityButton();


    ctrl.hasAdvanceCancellationPermission = () => {
        UserService.hasUserSystemPermission({
            permission: 'advancecancellation'
        })
            .then(canAdvanceCancellation => {
                $scope.canAdvanceCancellation = canAdvanceCancellation;
            });
    };
    ctrl.hasAdvanceCancellationPermission();


    ctrl.goBackOne = () => {
        window.history.back();
    };

    ctrl.getActivities = () => {
        return ActivityService.getActivitiesForPolicy($stateParams.policyNumber);
    };
    //UCWAR-201 GVO Policy Cancellation
    $scope.policyValidation = {
        'isValid': false,
        'validationErrorMessage': ''
    };

    ctrl.showCancellationForm = () => {
        //UCWAR-201 GVO Policy Cancellation
        if ($scope.policy.numberOfOpenClaims == 0) {
            ctrl.getMakerWarrantyEnd();
            ctrl.getEffectiveDate();
            const effectiveDate = new Date($scope.effectiveDate);
            const makerWarrantyEnd = new Date($scope.makerWarrantyEnd);
            const effectiveDatePlusFifteen = new Date(effectiveDate.getFullYear(), effectiveDate.getMonth(), effectiveDate.getDate() + 15);
            if (makerWarrantyEnd > effectiveDatePlusFifteen && $scope.currentDate > makerWarrantyEnd) {

                $scope.policyValidation.isValid = false;
                ModalService.showError('gateway.views.modal.Error', 'gateway.directives.cancel-policy.Cancel Policy Error');
                return;
            } else if (makerWarrantyEnd <= effectiveDatePlusFifteen && $scope.currentDate > effectiveDatePlusFifteen) {

                $scope.policyValidation.isValid = false;
                ModalService.showError('gateway.views.modal.Error', 'gateway.directives.cancel-policy.Cancel Policy Error');
                return;
            } else if (makerWarrantyEnd < $scope.currentDate && $scope.currentDate > effectiveDatePlusFifteen) {

                $scope.policyValidation.isValid = false;
                ModalService.showError('gateway.views.modal.Error', 'gateway.directives.cancel-policy.Cancel Policy Error');
                return;
            }

        } else {
            $scope.policyValidation.isValid = false;
            ModalService.showError('gateway.views.modal.Error', 'gateway.directives.cancel-policy.Cancel Policy Error');
            return;
        }
        if ($scope.formIsOpen) {
            return;
        }
        $scope.formIsOpen = true;
        $scope.cancelFormIsVisible = true;
    };
    ctrl.getMakerWarrantyEnd = () => {
        if (Object.keys($scope.policy.lobs.puw_PSA).length != 0) {
            $scope.policy.lobs.puw_PSA.vehicleDTOs.forEach(coverable => {
                if (coverable.coverages.length > 0) {
                    $scope.makerWarrantyEnd = coverable.makerWarrantyEnd;
                }
            });
        }
        if (Object.keys($scope.policy.lobs.egvn_psa).length != 0) {
            $scope.policy.lobs.egvn_psa.vehicleDTOs.forEach(coverable => {
                if (coverable.coverages.length > 0) {
                    $scope.makerWarrantyEnd = coverable.makerWarrantyEnd;
                }
            });
        }
    };

    ctrl.getEffectiveDate = () => {

        if ($scope.policy.latestPeriod.effectiveDate) {

            $scope.effectiveDate = $scope.policy.latestPeriod.effectiveDate;
        }

    };

    ctrl.hideCancellationForm = () => {
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
    };

    ctrl.showChangeForm = () => {
        if ($scope.formIsOpen) {
            return;
        }

        const lobCode = $scope.latestPeriod.policyLines[0].lineOfBusinessCode;
        if ($scope.gatewayEndorsementEnabled && ApplicationFeatures.hasFeature(`endorsement-products.${lobCode}`)) {
            const nextPage = SupportedTransactionLOBs.includes(lobCode) ? 'endorsementTransactionEntry' : 'endorsementWithPolicy';

            $state.transitionTo(nextPage, {
                selectedPolicyNumber: $scope.policyNumber
            });
        } else {
            $scope.formIsOpen = true;
            $scope.changeFormIsVisible = true;
        }
    };

    ctrl.hideChangeForm = () => {
        $scope.formIsOpen = false;
        $scope.changeFormIsVisible = false;
    };

    ctrl.showRenewForm = () => {
        if ($scope.formIsOpen) {
            return;
        }
        $scope.formIsOpen = true;
        $scope.renewFormIsVisible = true;
    };

    ctrl.hideRenewForm = () => {
        $scope.formIsOpen = false;
        $scope.renewFormIsVisible = false;
    };

    ctrl.createPolicyRenewalTransaction = () => {
        if ($scope.formIsOpen) {
            return;
        }

        const lobCode = $scope.latestPeriod.policyLines[0].lineOfBusinessCode;
        const newPolicyRenewalRequest = PolicyService.createNewPolicyRenewalTransaction($stateParams.policyNumber);

        if (SupportedTransactionLOBs.includes(lobCode)) {
            newPolicyRenewalRequest.then(({ jobNumber: selectedRenewal }) => {
                $state.transitionTo('renewalTransactionEntry', {
                    selectedRenewal,
                    resume: false
                });
            });
        } else {
            $scope.formIsOpen = true;
            $scope.renewFormIsVisible = true;
            $scope.newPolicyRenewalRequest = newPolicyRenewalRequest;

            $q.when(newPolicyRenewalRequest, (job) => {
                $window.location.href = `${GPA_PC_ENTRY_POINT}?JobNumber=${job.jobNumber}`;
            }, (error) => {
                ModalService.showError('Error', error.baseError.data.error.message);
                $scope.hideRenewForm();
            });
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['$state', '$translate', '$scope', '$q', '$stateParams', 'AccountService', 'PolicyService', 'ActivityService', '$modal', '$window', 'ModalService', '$filter', 'UserService', 'TranslateService', 'GPA_PC_ENTRY_POINT'];

export default fn;
